import React from "react";
import { Col, Row, Button, Typography, Divider, Dropdown, Menu, Tooltip } from 'antd'
import JenkinsListing from "views/JenkinsResult/JenkinsListing";
import { BASE_GUTTER } from "constants/Layout";
import ModalUtil from "utils/modalUtil";
import AuthorisedContainer from "components/AuthorisedContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import { AdditionalSettingIcon } from "components/Icons";
import { withFeatureFlags } from "contexts/FeatureFlagContext";
import GithubActionsFormPopup from "./GithubActionsFormPopup";



const GithubActionsDashboard = (props) => {
  const toolName = props.id;

  const showScriptPopup = (selectedMenuKey) => {
    ModalUtil.show({
      content: <GithubActionsFormPopup id={toolName} selectedMenuKey={selectedMenuKey} />,
    });
  }

  const getMenu = () => {
    return (
      <Menu onClick={({ key }) => showScriptPopup(key)}>
        <Menu.Item key="githubActionsArmorcode">Armorcode Github Action</Menu.Item>
        <Menu.Item key="githubActionsScript">Script</Menu.Item>
      </Menu>
    );
  }

  return (
    <Row gutter={BASE_GUTTER}>
      <Col className="d-flex justify-content-flex-end align-items-center" span={24}>
        <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
          <Dropdown overlay={getMenu()} trigger={["click"]}>
            <Button type="primary">
              Connect to Github Actions
            </Button>
          </Dropdown>
        </AuthorisedContainer>
        <Divider type="vertical" />
        <Tooltip title="Edit Release Gate" placement="topRight">
          <Typography.Link href="#/globalsettings?activeStep=step15">
            <AdditionalSettingIcon className="clickable"/>
          </Typography.Link>
        </Tooltip>
      </Col>
      <Col span={24}>
        <JenkinsListing id={toolName} />
      </Col>
    </Row>
  );
}

export default withFeatureFlags(GithubActionsDashboard);